import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export const downloadTaskExcelTemplate = () => {
  const headers = ["Question", "Question Type", "Description", "Choices", "is Required"];

  const exampleRows = [
    ["Time spent on this task", "Free Text", "Total time spent on the task (in minutes)", "", "Yes"],
    ["Task complexity level", "single select list", "Select the complexity level of the task", "Low; Medium; High", "Yes"],
    ["Was the task completed successfully?", "single select list", "Indicate whether the task was completed", "Yes; No", "Yes"],
    ["Reason if task was not completed", "Free Text", "Provide reason if the task could not be completed", "", "No"],
  ];

  const worksheetData = [headers, ...exampleRows];
  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

  // Set column widths
  worksheet["!cols"] = [
    { wch: 40 },
    { wch: 18 },
    { wch: 50 },
    { wch: 30 },
    { wch: 14 },
  ];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Task Template");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(blob, "Task_Template.xlsx");
};
